import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { App } from './app/App';
import { ApiError } from './api/client';
import './app/base.css';
import './ui/theme.css';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // A 401 or 403 is a real answer. Retrying it just delays the redirect to login.
      retry: (failureCount, error) =>
        error instanceof ApiError && !error.isRetryable ? false : failureCount < 2,
      refetchOnWindowFocus: true,
      staleTime: 15_000,
    },
    mutations: {
      // Pick auto-save runs its own retry with backoff, so the global default stays off
      // to avoid two layers of retry fighting each other.
      retry: false,
    },
  },
});

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </QueryClientProvider>
  </StrictMode>,
);
